import React from 'react';

type LoadingOverlayProps = {
    show: boolean;
    label?: string;
    /**
     * When true, uses a fixed full-screen overlay.
     * When false, uses an absolute overlay (parent must be `relative`).
     */
    fullscreen?: boolean;
};

const Spinner = () => (
    <div
        className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600"
        aria-hidden="true"
    />
);

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
    show,
    label = 'Loading…',
    fullscreen = true,
}) => {
    if (!show) return null;

    return (
        <div
            className={[
                fullscreen ? 'fixed inset-0' : 'absolute inset-0',
                'z-50 flex items-center justify-center',
                'bg-white/60 backdrop-blur-sm',
            ].join(' ')}
            role="status"
            aria-live="polite"
            aria-label={label}
        >
            <div className="flex items-center gap-3 rounded-xl bg-white/90 px-5 py-4 shadow-lg border border-slate-200">
                <Spinner />
                <div className="text-sm font-semibold text-slate-700">{label}</div>
            </div>
        </div>
    );
};

export default LoadingOverlay;


